import React, { Component } from 'react';
// import 'semantic-ui-css/semantic.min.css'; // Removed to avoid duplicate styles
import {
  Container,
  Header,
  Grid,
  // Segment, // Removed as not used
  // List, // Removed as not used in the provided snippet, but kept in original render
  Menu,
  Button,
  Table,
  Icon,
  Image,
  // Dropdown, // Removed as not used
  Pagination,
  Loader,
  Label,
  List
} from '../../node_modules/semantic-ui-react';
import { ajaxPost } from '../ajax';
import { checkDateRange, isTaskAvailable } from '../utils';

// Modals
import TardinessModal from './ReportModels/TardinessModal';
import LateReportModel from './ReportModels/LateReportModel'; // Used for detailed reports
import OvertimePremiumReportModal from './ReportModels/OvertimePremiumReportModal';
import LeaveSummaryReportModal from './ReportModels/Leaves/LeaveSummaryReportModal';
import PerfectAttendanceModal from './ReportModels/PerfectAttendanceModal';

// Models
import AbsencesDetailedReportModel from './ReportModels/AbsencesDetailedReportModel';
import AbsencesSummaryReportModel from './ReportModels/AbsenceSummaryReportModel';
import LeaveSummaryReportModel from './ReportModels/Leaves/LeaveSummaryReportModel';
import OvertimeDetailedReportModel from './ReportModels/OvertimeDetailedReportModel';
import OvertimeSummaryReportModel from './ReportModels/OvertimeSummaryReportModel';
import OvertimePremiumReportModel from './ReportModels/OvertimePremiumReportModel';
import DetailedTardinessReportModel from './ReportModels/DetailedTardinessReportModel'; // Named differently from Modal
import TardinessSummaryReportModel from './ReportModels/TardinessSummaryReportModel';
import UndertimeDetailedReportModel from './ReportModels/UndertimeDetailedReportModel';
import UndertimeSummaryReportModel from './ReportModels/UndertimeSummaryReportModel';
import AttendanceAnalyticReportModel from './ReportModels/AttendanceAnalyticReportModel';
import PerfectAttendanceReportModel from './ReportModels/EmployeeReport/PerfectAttendanceReportModel';

class DTRReports extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      activeReport: 'Absences Detailed Report',
      reportModel: null,
      rows: [],
      loading: false,
      isFilterActive: false,
      parameters: null,

      // Pagination
      activePage: 1,
      totalPages: 0,
      totalResultsCount: 0,
      itemsPerPage: 20,

      disAbleExport: true,
    };

    this.filter = React.createRef();
    this.pollingTimer = null;
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.props.prevState) {
      this.restoreState(this.props.prevState);
    } else {
      // Initialize with the default active report based on availability
      let defaultReport = 'Absences Detailed Report';
      if (!isTaskAvailable("DTR_VIEW") && isTaskAvailable("LEAVE_SUMMARY_VIEW")) {
        defaultReport = 'Leave Summary Report';
      }
      this.setReportModel(defaultReport);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
    }
    if (this.props.unmountCallback) {
      const stateToSave = { ...this.state };
      // Do not save the ReportModel instance as it is not serializable/safe
      delete stateToSave.reportModel;
      this.props.unmountCallback(stateToSave, "DTRReports");
    }
  }

  restoreState = (prevState) => {
    // Re-create the report model instance based on the saved activeReport
    const reportModel = this.createReportModel(prevState.activeReport);
    this.setState({
      ...prevState,
      reportModel
    });
  }

  createReportModel = (reportType) => {
    switch (reportType) {
      case 'Absences Detailed Report':
        return new AbsencesDetailedReportModel();
      case 'Absences Summary Report':
        return new AbsencesSummaryReportModel();
      case 'Leave Summary Report':
        return new LeaveSummaryReportModel();
      case 'Overtime Detailed Report':
        return new OvertimeDetailedReportModel();
      case 'Overtime Summary Report':
        return new OvertimeSummaryReportModel();
      case 'Overtime Premium Report':
        return new OvertimePremiumReportModel();
      case 'Tardiness Detailed Report':
        return new DetailedTardinessReportModel();
      case 'Tardiness Summary Report':
        return new TardinessSummaryReportModel();
      case 'Undertime Detailed Report':
        return new UndertimeDetailedReportModel();
      case 'Undertime Summary Report':
        return new UndertimeSummaryReportModel();
      case 'Attendance Analytic Report':
        return new AttendanceAnalyticReportModel();
      case 'Perfect Attendance Report':
        return new PerfectAttendanceReportModel();
      default:
        return null;
    }
  }

  setReportModel = (reportType) => {
    const reportModel = this.createReportModel(reportType);

    if (this._isMounted) {
      this.setState({
        reportModel,
        activeReport: reportType,
        rows: [],
        totalResultsCount: 0,
        totalPages: 0,
        activePage: 1,
        disAbleExport: true,
        parameters: null,
        isFilterActive: false
      });
    }
  };

  handleReportClick = (report) => {
    this.setReportModel(report);
  };

  showFilters = () => {
    if (this.state.loading) {
      alert("Please wait until the process is done.");
      return;
    }
    this.setState({ isFilterActive: true });
  }

  btnGenerate_Click = () => {
    if (!this.filter.current) return;

    const params = this.filter.current.getParameters();

    // Validate date range parameters before preventing modal close
    if (params.fromDate !== undefined && params.toDate !== undefined) {
      var checkDateParam = checkDateRange(params.fromDate, params.toDate);
      if (!checkDateParam.Result) {
        alert(checkDateParam.Message);
        return;
      }
    }

    this.setState({ parameters: params, isFilterActive: false, activePage: 1 }, () => {
      // Wait for modal to clear before starting heavier operations
      setTimeout(() => {
        if (this._isMounted) {
          this.setState({ disAbleExport: false }, this.onSearch);
        }
      }, 500);
    });
  }

  onSearch = () => {
    this.setState({ rows: [], loading: true });
    const { parameters, activePage, itemsPerPage, reportModel, activeReport } = this.state;

    let searchParams = { ...parameters };
    searchParams.pageNumber = activePage;
    searchParams.itemsPerPage = itemsPerPage;
    searchParams.ReportTitle = activeReport;

    reportModel.search(
      searchParams,
      (data) => {
        // For DTR reports, we often get a processId for background processing
        // Similar to ReportBase.js line 430 logic
        // But let's check what checking logic ReportBase uses.
        // It checks if ReportTitle is in dtrReport array.
        // All reports here are likely DTR reports or behave similarly.

        // Wait, Absences/Overtime/Tardiness/Undertime are in dtrReport array.
        // Leave Summary is NOT in dtrReport array.

        const dtrReports = ["Absences Summary Report", "Absences Detailed Report", "Overtime Summary Report", "Overtime Premium Report", "Undertime Summary Report",
          "Tardiness Summary Report", "Overtime Detailed Report", "Undertime Detailed Report", "Tardiness Detailed Report", "Attendance Analytic Report", "Perfect Attendance Report"];

        if (dtrReports.includes(activeReport)) {
          var param = { processId: data };
          this.startPolling(param, "GENERATE");
        } else {
          this.populateRows(data);
        }
      },
      (error) => {
        alert("Error:\r\n" + JSON.stringify(error));
        if (this._isMounted) this.setState({ loading: false });
      },
      () => { }
    );
  }

  startPolling = (param, action) => {
    // Clear any existing timer
    if (this.pollingTimer) clearInterval(this.pollingTimer);

    this.pollingTimer = setInterval(() => {
      if (!this._isMounted) {
        clearInterval(this.pollingTimer);
        return;
      }

      ajaxPost({
        data: param,
        url: 'api/BackgroundProcess/GetStatus',
        onSuccess: data => {
          if (data.Status === "DONE") {
            clearInterval(this.pollingTimer); // Stop polling

            // Decouple UI update
            setTimeout(() => {
              if (this._isMounted) {
                if (action === "GENERATE") {
                  this.populateRows(JSON.parse(data.ResultParameters));
                } else if (action === "GENERATE_PDF") {
                  this.state.reportModel.processPdfData(JSON.parse(data.ResultParameters));
                  this.setState({ loading: false });
                } else if (action === "GENERATE_EXCEL") {
                  this.state.reportModel.exportToExcel(JSON.parse(data.ResultParameters),
                    data => { },
                    (err) => { },
                    () => { }
                  );
                  this.setState({ loading: false });
                }

                // Clear background process
                this.cleanBackgroundProcess(param);
              }
            }, 100);
          }
        },
        onError: (error) => {
          // If error, stop polling and show alert
          clearInterval(this.pollingTimer);
          alert("Error status:\r\n" + JSON.stringify(error));
          if (this._isMounted) this.setState({ loading: false });
        },
        finally: () => { }
      });
    }, 1000); // Check every 1 second
  }

  cleanBackgroundProcess = (param) => {
    setTimeout(() => {
      ajaxPost({
        data: param,
        url: 'api/BackgroundProcess/Delete',
        onSuccess: data => { },
        onError: (err) => { },
        finally: () => { }
      });
    }, 500);
  }

  populateRows = (data) => {
    let rows = [];
    if (data.Data) {
      data.Data.forEach(element => {
        rows.push(this.state.reportModel.toTableRow(element));
      });
    }

    // Handle null/undefined TotalCount - default to 0
    const totalCount = data.TotalCount ?? 0;

    let totalPages = 0;
    if (this.state.itemsPerPage > 0 && totalCount > 0) {
      totalPages = Math.ceil(totalCount / this.state.itemsPerPage);
    }

    // Ensure at least 1 page to prevent invalid pagination display
    if (totalPages === 0) {
      totalPages = 1;
    }

    if (this._isMounted) {
      this.setState({
        rows: rows,
        totalResultsCount: totalCount,
        totalPages: totalPages,
        loading: false
      }, () => {
        // Safety cleanup for Semantic UI Modals
        try {
          document.body.classList.remove('dimmed');
          document.body.classList.remove('scrolling');
          document.body.classList.remove('blurring');
        } catch (e) {
          console.error("Cleanup error", e);
        }
      });
    }
  }

  onPageChange = (event, { activePage }) => {
    const page = Math.floor(activePage); // Ensure integer
    if (page === this.state.activePage) return;

    this.setState({ activePage: page }, () => {
      if (!this.state.disAbleExport) {
        this.onSearch();
      }
    });
  }

  onExportToExcel = () => {
    const { reportModel, loading, parameters, activeReport } = this.state;
    if (!reportModel) return;
    if (loading) {
      alert("Please wait until the process is done.");
      return;
    }

    this.setState({ loading: true });
    let exportParams = { ...parameters };
    exportParams.pageNumber = 0;
    exportParams.itemsPerPage = 2147483647;
    exportParams.ReportTitle = activeReport;
    exportParams.sessionId = global.sessionId;

    const dtrReports = ["Absences Summary Report", "Absences Detailed Report", "Overtime Summary Report", "Overtime Premium Report", "Undertime Summary Report",
      "Tardiness Summary Report", "Overtime Detailed Report", "Undertime Detailed Report", "Tardiness Detailed Report", "Attendance Analytic Report", "Perfect Attendance Report"];

    if (dtrReports.includes(activeReport)) {
      // Checking ReportBase.js logic for Export...
      // For DTR reports it uses exportToExcelData -> getUpdate -> exportToExcel
      // Wait, for Loan/Payroll/DTR/Employee it uses exportToExcelData.

      reportModel.exportToExcelData(
        exportParams,
        (data) => {
          if (dtrReports.includes(activeReport)) {
            var param = { processId: data };
            this.startPolling(param, "GENERATE_EXCEL");
          }
        },
        (error) => {
          alert("Error:\r\n" + JSON.stringify(error));
          if (this._isMounted) this.setState({ loading: false });
        },
        () => { }
      );
    } else {
      // Fallback
      reportModel.exportToExcel(
        { ...exportParams, itemCount: 2147483647 },
        (data) => { if (this._isMounted) this.setState({ loading: false }); },
        (error) => { alert("Error:\r\n" + JSON.stringify(error)); if (this._isMounted) this.setState({ loading: false }); },
        () => { }
      );
    }
  }

  onExportToPdf = () => {
    const { reportModel, loading, parameters, activeReport } = this.state;
    if (!reportModel) return;
    if (loading) {
      alert("Please wait until the process is done.");
      return;
    }
    this.setState({ loading: true });

    let exportParams = { ...parameters };
    exportParams.pageNumber = this.state.activePage;
    exportParams.itemsPerPage = this.state.itemsPerPage;
    exportParams.ReportTitle = activeReport;
    exportParams.itemCount = 2147483647;

    reportModel.exportToPdf(
      exportParams,
      (data) => {
        const dtrReports = ["Absences Summary Report", "Absences Detailed Report", "Overtime Summary Report", "Overtime Premium Report", "Undertime Summary Report",
          "Tardiness Summary Report", "Overtime Detailed Report", "Undertime Detailed Report", "Tardiness Detailed Report", "Attendance Analytic Report"];

        if (activeReport === 'Perfect Attendance Report') {
          // createPerfectAttendanceReportToPDF returns the finished pdfmake doc
          // synchronously (unlike the other DTR reports), so it must not be
          // polled via BackgroundProcess/GetStatus.
          reportModel.processSTDPdfData(data);
          if (this._isMounted) this.setState({ loading: false });
        } else if (dtrReports.includes(activeReport)) {
          var param = { processId: data };
          this.startPolling(param, "GENERATE_PDF");
        } else {
          reportModel.processPdfData(data);
          if (this._isMounted) this.setState({ loading: false });
        }
      },
      (error) => {
        alert("Error:\r\n" + JSON.stringify(error));
        if (this._isMounted) this.setState({ loading: false });
      },
      () => { }
    );
  }

  renderFilters = () => {
    const { activeReport, isFilterActive } = this.state;

    // IMPORTANT: Return null if not active to trigger full unmount/cleanup
    if (!isFilterActive) return null;

    // Determine which modal to render
    // Logic from ReportBase.js

    if (activeReport === 'Overtime Premium Report') {
      return (
        <OvertimePremiumReportModal
          ref={this.filter}
          open={true}
          onSave={this.btnGenerate_Click}
          onCancel={() => this.setState({ isFilterActive: false })}
        />
      );
    }

    if (activeReport === 'Leave Summary Report') {
      return (
        <LeaveSummaryReportModal
          ref={this.filter}
          open={true}
          onSave={this.btnGenerate_Click}
          onCancel={() => this.setState({ isFilterActive: false })}
        />
      );
    }

    if (activeReport === 'Perfect Attendance Report') {
      return (
        <PerfectAttendanceModal
          ref={this.filter}
          open={true}
          onSave={this.btnGenerate_Click}
          onCancel={() => this.setState({ isFilterActive: false })}
        />
      );
    }

    if (['Tardiness Detailed Report', 'Tardiness Summary Report',
      'Overtime Detailed Report', 'Overtime Summary Report'].includes(activeReport)) {
      return (
        <LateReportModel
          ref={this.filter}
          open={true}
          onSave={this.btnGenerate_Click}
          onCancel={() => this.setState({ isFilterActive: false })}
        />
      );
    }

    // Default to TardinessModal for Absences, Undertime, etc.
    // DTRReports includes Absences, Undertime.
    return (
      <TardinessModal
        ref={this.filter}
        open={true}
        onSave={this.btnGenerate_Click}
        onCancel={() => this.setState({ isFilterActive: false })}
      />
    );
  }

  render() {
    const { activeReport, reportModel, rows, loading, totalResultsCount, activePage, totalPages, disAbleExport } = this.state;

    const reports = [
      'Absences Detailed Report',
      'Absences Summary Report',
      'Leave Summary Report',
      'Perfect Attendance Report',
      'Overtime Detailed Report',
      'Overtime Summary Report',
      'Overtime Premium Report',
      'Tardiness Detailed Report',
      'Tardiness Summary Report',
      'Undertime Detailed Report',
      'Undertime Summary Report'
    ].filter(report => {
      if (report === 'Leave Summary Report') {
        return isTaskAvailable("LEAVE_SUMMARY_VIEW");
      }
      return isTaskAvailable("DTR_VIEW");
    });
    return (
      <Container fluid>
        <Header as="h2" style={{ marginBottom: '16px' }}>
          DTR Report
        </Header>

        <Grid>
          <Grid.Column width={3}>
            <List selection verticalAlign='middle'>
              {reports.map(report => {
                const isActive = activeReport === report;
                const style = {
                  cursor: 'pointer',
                  color: isActive ? '#000' : '#888',
                  fontWeight: isActive ? 600 : 400,
                  padding: '10px',
                  backgroundColor: isActive ? '#f0f0f0' : 'transparent',
                  borderRadius: '4px'
                };

                return (
                  <List.Item
                    key={report}
                    onClick={() => this.handleReportClick(report)}
                    style={style}
                  >
                    <List.Content>
                      <List.Header>{report}</List.Header>
                    </List.Content>
                  </List.Item>
                );
              })}
            </List>
          </Grid.Column>

          <Grid.Column width={13}>
            {/* Flex container to manage layout and scrolling */}
            <div style={{ padding: 0, marginTop: '1em', display: 'flex', flexDirection: 'column', height: 'calc(100vh - 150px)' }}>
              <Header as="h3">{activeReport}</Header>

              {/* zIndex ensures controls stay on top of any rogue overlays */}
              <div style={{ zIndex: 1000, position: 'relative', margin: '0.5em 0.1em' }}>
                <Menu secondary size="mini" stackable>
                  <Button size="mini" content="Generate" onClick={this.showFilters} />
                  <Button size="mini" content="Export To Excel" disabled={disAbleExport} onClick={this.onExportToExcel} />
                  <Button size="mini" content="Export To PDF" disabled={disAbleExport} onClick={this.onExportToPdf} />
                  <Loader active={loading} inline='left' style={{ margin: '0 0.5em' }} />

                  <Menu.Menu position="right">
                    <Label>Total Results Count: {totalResultsCount}</Label>
                    <Pagination
                      size="mini"
                      activePage={activePage}
                      totalPages={totalPages}
                      onPageChange={this.onPageChange}
                      firstItem={{ content: <Icon name='angle double left' />, icon: true }}
                      lastItem={{ content: <Icon name='angle double right' />, icon: true }}
                      prevItem={{ content: <Icon name='angle left' />, icon: true }}
                      nextItem={{ content: <Icon name='angle right' />, icon: true }}
                    />
                  </Menu.Menu>
                </Menu>
              </div>

              {/* Scrollable container for table */}
              <div style={{ flex: 1, overflow: 'auto', border: '1px solid rgba(34,36,38,.15)', borderRadius: '4px' }}>
                <Table celled striped compact size='small' style={{ border: 'none' }}>
                  <Table.Header>
                    {reportModel && reportModel.createColumnHeaders()}
                  </Table.Header>
                  <Table.Body>
                    {rows}
                  </Table.Body>
                </Table>
              </div>
            </div>
          </Grid.Column>
        </Grid>

        {this.renderFilters()}
      </Container>
    );
  }
}

DTRReports.getViewID = () => {
  return "DTRReports";
};

DTRReports.getCaption = () => {
  return "DTR Reports";
};

DTRReports.getViewAccessKey = () => {
  return isTaskAvailable("DTR_VIEW") || isTaskAvailable("LEAVE_SUMMARY_VIEW") ? true : false
};

DTRReports.getIcon = () => {
  return (<Image style={{ height: "24px", width: "24px" }} src="/Icons/Reports.png" avatar />);
};

DTRReports.getIconSrc = (size) => {
  return '/Icons/Reports.png';
};

export default DTRReports;
